import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    Pagination,
    Box,
    Typography,
    CircularProgress,
    InputAdornment
} from '@mui/material';
import { FaSearch } from 'react-icons/fa';

const DataTable = ({
    columns,
    data,
    loading,
    page,
    count,
    rowsPerPage = 10,
    onPageChange,
    onSearch,
    searchPlaceholder = "Search...",
    actions
}) => {
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        if (onSearch) {
            onSearch(e.target.value);
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            {/* Header / Search */}
            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {onSearch && (
                    <TextField
                        variant="outlined"
                        size="small"
                        placeholder={searchPlaceholder}
                        value={searchTerm}
                        onChange={handleSearchChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <FaSearch color="#666" />
                                </InputAdornment>
                            ),
                        }}
                        sx={{ width: 300 }}
                    />
                )}
                {/* Helper Actions like 'Add New' button can be injected here */}
                {actions}
            </Box>

            {/* Table */}
            <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #eee' }}>
                <Table sx={{ minWidth: 650 }} aria-label="data table">
                    <TableHead sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableRow>
                            {columns.map((col) => (
                                <TableCell key={col.id} sx={{ fontWeight: 'bold' }}>
                                    {col.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? (
                            <TableRow>
                                <TableCell colSpan={columns.length} align="center" sx={{ py: 5 }}>
                                    <CircularProgress size={30} />
                                </TableCell>
                            </TableRow>
                        ) : data.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={columns.length} align="center" sx={{ py: 5 }}>
                                    <Typography variant="body1" color="textSecondary">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            data.map((row, rowIndex) => (
                                <TableRow
                                    key={row.id || rowIndex}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    {columns.map((col) => (
                                        <TableCell key={col.id}>
                                            {col.render ? col.render(row) : row[col.id]}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Pagination */}
            {count > rowsPerPage && (
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                    <Pagination
                        count={Math.ceil(count / rowsPerPage)}
                        page={page}
                        onChange={onPageChange}
                        color="primary"
                    />
                </Box>
            )}
        </Box>
    );
};

export default DataTable;
